function removeListValue(list: string[], value: string): string[] {
	return list.filter((item) => item !== value);
}

function pushUniqueValue(list: string[], value: string): string[] {
	if (!list.includes(value)) {
		list.push(value);
	}
	return list;
}

function isEmptyObject(object: unknown): boolean {
	if (object && Object.keys(object).length && object?.constructor === Object) {
		return false;
	}
	return true;
}

const getElementIndex = (list: object[], element: object, key = "_id"): number =>
	list.findIndex((item: object) => item?.[key as keyof object] === element?.[key as keyof object]);

function getObjectInList(list: string[], attribute: string, value: unknown) {
	return list.find((element) => element?.[attribute as keyof object] === value);
}

function isObjectInList(list: string[], index: string, value: unknown): boolean {
	const object = getObjectInList(list, index, value);
	return !isEmptyObject(object);
}

const range = (start: number, stop: number, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

const getCountWords = (collection = [], index = "") => {
	let firstWords = null;
	let secondWords = null;

	if (index) {
		firstWords = collection.reduce((prev: { [key: string]: number }, next: object) => {
			const firstWordNext = (next[index as keyof object] as string).replace(/ .*/, "").trim();
			prev[firstWordNext as keyof object] = prev[firstWordNext as keyof object] + 1 || 1;
			return prev;
		}, {});

		secondWords = collection.reduce((prev: { [key: string]: number }, next) => {
			let firstTwoWords = (next[index as keyof object] as string).split(" ").slice(0, 2).join(" ");
			firstTwoWords = firstTwoWords.trim();
			prev[firstTwoWords] = prev[firstTwoWords as keyof object] + 1 || 1;
			return prev;
		}, {});
	}

	if (firstWords) {
		const filterObject = Object.entries(firstWords);
		const filtered = filterObject.filter(([key, value]) => key && value > 1);
		firstWords = Object.fromEntries(filtered);
	}

	if (secondWords) {
		const filterObject = Object.entries(secondWords);
		const filtered = filterObject.filter(([key, value]) => key && value > 1);
		secondWords = Object.fromEntries(filtered);
	}

	return {
		firstWords,
		secondWords,
	};
};

const findSimilarInObjectCollection = (collection = [], index = "") => {
	let similar = [];

	if (index) {
		const { firstWords, secondWords } = getCountWords(collection, index);
		const similarCounter = { ...firstWords, ...secondWords };

		for (const word in similarCounter) {
			if (similarCounter?.[word as keyof object] > 1) {
				similar.push(word);
			}
		}
	}

	similar = [...new Set(similar)];
	return similar.map((element) => {
		return {
			[index]: `${element}*`,
		};
	});
};

function transformArrayWithProperties<T>(properties: string[], ...arrays: T[][]): Array<{ [key: string]: T }>[];
function transformArrayWithProperties<T>(...arrays: T[][]): Array<{ [key: string]: T }>[];
function transformArrayWithProperties<T>(propertiesOrArray: string[] | T[][], ...arrays: T[][]): Array<{ [key: string]: T }>[] {
	let properties: string[];
	let dataArrays: T[][];

	if (Array.isArray(propertiesOrArray) && typeof propertiesOrArray[0] === "string") {
		// First argument is properties array
		properties = propertiesOrArray as string[];
		dataArrays = arrays;
	} else {
		// Properties argument omitted; use default properties
		properties = ["value", "label"];
		dataArrays = [propertiesOrArray as T[], ...arrays];
	}

	return dataArrays.map((array) =>
		array.map((item) => {
			const transformedItem: { [key: string]: T } = {};
			properties.forEach((prop) => {
				transformedItem[prop] = item;
			});
			return transformedItem;
		})
	);
}

export {
	findSimilarInObjectCollection,
	getElementIndex,
	getObjectInList,
	isEmptyObject,
	isObjectInList,
	pushUniqueValue,
	range,
	removeListValue,
	transformArrayWithProperties,
};
